<ng-container *transloco="let t">
<form #militaryServiceForm="ngForm" novalidate id="militaryServiceForm" name="militaryServiceForm">
  <div class="row mb-5" [ngClass]="{'border-danger': hasServedInMilitary.touched && hasServedInMilitary.invalid}">
    <div class="col-lg-10 col-md-12">
      <div class="position-relative" style="font-size: 15px;">
        {{ t('wizard.military.question') }}
      </div>
    </div>
    <div class="col-lg-2 col-sm-6">
      <div class="d-flex">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" name="hasServedInMilitary" required [value]="true" type="radio" id="yes{{borrower.borrowerId}}"
            [(ngModel)]="borrower.hasServedInMilitary" #hasServedInMilitary="ngModel"
            (ngModelChange)="onHasServedInMilitaryChanged()" />
          <label style="padding-right: 6px;" class="form-check-label" for="yes{{borrower.borrowerId}}">{{ t('common.yes') }}</label>
        </div>
        <div class="form-check form-check-custom form-check-solid ms-8">
          <input class="form-check-input" name="hasServedInMilitary" required [value]="false" type="radio" id="no{{borrower.borrowerId}}"
            [(ngModel)]="borrower.hasServedInMilitary" #hasServedInMilitary="ngModel"
            (ngModelChange)="onHasServedInMilitaryChanged()" />
          <label style="padding-right: 6px;" class="form-check-label" for="no{{borrower.borrowerId}}">{{ t('common.no') }}</label>
        </div>
      </div>
    </div>
  </div>
  @if (borrower.hasServedInMilitary) {
    @for (period of borrower.militaryServicePeriods; track period; let i = $index) {
      <div class="card shadow-sm mb-5">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">{{ t('wizard.military.servicePeriod') }} {{i + 1}}</h4>
          @if (borrower.militaryServicePeriods.length > 1) {
            <button type="button" class="btn btn-sm btn-light-danger" (click)="removeServicePeriod(i)">
              {{ t('wizard.military.remove') }}
            </button>
          }
        </div>
        <div class="card-body">
          <div class="row mb-8">
            <div class="col-md-6 fv-row">
              <label class="form-label required">{{ t('wizard.military.militaryStatus') }}</label>
              <select class="form-select form-select-solid" data-control="select2" name="militaryStatus_{{i}}"
                #periodMilitaryStatus="ngModel" [(ngModel)]="period.militaryStatus"
                (ngModelChange)="onMilitaryStatusChanged(period, i)"
                [ngClass]="{'is-invalid' : periodMilitaryStatus && periodMilitaryStatus.touched && periodMilitaryStatus.invalid}"
                required>
                <option value="" disabled>{{ t('common.selectOne') }}</option>
                <option [ngValue]="undefined" disabled>{{ t('common.selectOne') }}</option>
                @for (militaryStatusType of militaryStatusTypes; track militaryStatusType.value) {
                  <option [value]="militaryStatusType.value">
                    {{militaryStatusType.name}}</option>
                }
              </select>
            </div>
            @if (period.militaryStatus === 'ActiveDuty') {
              <div class="col-md-6 fv-row">
                <label class="form-label">{{ t('wizard.military.completionDate') }}</label>
                <div class="position-relative d-flex align-items-center">
                  <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true"
                    [specialCharacters]="[ '/' ]" [dropSpecialCharacters]="false" datePicker
                    #tourEndDate="ngModel"
                    [(ngModel)]="period.militaryTourEndDate" placeholder="" name="militaryTourEndDate_{{i}}" inputmode="numeric"
                    [ngClass]="{'is-invalid' : tourEndDate && tourEndDate.touched && tourEndDate.invalid}" />
                </div>
              </div>
            }
          </div>

          <div class="row mb-8">
            <div class="col-md-6 fv-row">
              <label class="form-label required">{{ t('wizard.military.branchOfService') }}</label>
              <select class="form-select form-select-solid" data-control="select2" name="branchOfService_{{i}}"
                #periodBranchOfService="ngModel" [(ngModel)]="period.branchOfService"
                (ngModelChange)="onBranchOfServiceChanged(period)"
                [ngClass]="{'is-invalid' : periodBranchOfService && periodBranchOfService.touched && periodBranchOfService.invalid}" required>
                <option [ngValue]="undefined" disabled>{{ t('common.selectOne') }}</option>
                @for (militaryBranchOfServiceType of militaryBranchOfServiceTypes; track militaryBranchOfServiceType.value) {
                  <option [value]="militaryBranchOfServiceType.value">
                    {{militaryBranchOfServiceType.name}}</option>
                }
              </select>
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-6 fv-row">
              <label class="form-label">{{ t('wizard.military.tourStartDate') }}</label>
              <div class="position-relative d-flex align-items-center">
                <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true"
                  [specialCharacters]="[ '/' ]" [dropSpecialCharacters]="false" datePicker
                  #tourStartDate="ngModel"
                  [(ngModel)]="period.militaryTourStartDate" placeholder="" name="militaryTourStartDate_{{i}}" inputmode="numeric"
                  [ngClass]="{'is-invalid' : tourStartDate && tourStartDate.touched && tourStartDate.invalid}" />
              </div>
            </div>
            <div class="col-md-6 fv-row">
              <label class="form-label">{{ t('wizard.military.serviceNumber') }}</label>
              <input class="form-control form-control-solid" type="text"
                [(ngModel)]="period.militaryServiceNumber" name="militaryServiceNumber_{{i}}" />
            </div>
          </div>

          <div class="row mb-8">
            <div class="col-md-6 fv-row">
              <label class="form-label">{{ t('wizard.military.servedAsName') }}</label>
              <input class="form-control form-control-solid" type="text"
                [(ngModel)]="period.militaryServedAsName" name="militaryServedAsName_{{i}}" />
            </div>
          </div>
        </div>
      </div>
    }

    <div class="row mb-5">
      <div class="col-12">
        <button type="button" class="btn btn-light-primary" (click)="addServicePeriod()">
          {{ t('wizard.military.addServicePeriod') }}
        </button>
      </div>
    </div>

    <div class="row mb-4">
      <div class="checkbox mb-2">
        <label class="form-check form-check-inline form-check-solid me-2" for="isFirstUseOfVaBenefit">
          <input id="isFirstUseOfVaBenefit" name="isFirstUseOfVaBenefit" type="checkbox"
            [(ngModel)]="borrower.isFirstUseOfVaBenefit" class="form-check-input">
          <span class="fw-bold ps-2 fs-5">{{ t('wizard.military.firstTimeUse') }}</span>
        </label>
      </div>
      <div class="checkbox mb-2">
        <label class="form-check form-check-inline form-check-solid me-2" for="isVaFundingFeeExempt">
          <input id="isVaFundingFeeExempt" name="isVaFundingFeeExempt" type="checkbox"
            [(ngModel)]="borrower.isVaFundingFeeExempt" class="form-check-input">
          <span class="fw-bold ps-2 fs-5">{{ t('wizard.military.exemptFromFundingFee') }}</span>
        </label>
      </div>
      <div class="checkbox mb-2">
        <label class="form-check form-check-inline form-check-solid me-2" for="isSurvivingSpouseOfMilitary">
          <input id="isSurvivingSpouseOfMilitary" name="isSurvivingSpouseOfMilitary" type="checkbox"
            [(ngModel)]="borrower.isSurvivingSpouseOfMilitary" class="form-check-input">
          <span class="fw-bold ps-2 fs-5">{{ t('wizard.military.survivingSpouse') }}</span>
        </label>
      </div>
    </div>
  }
</form>
</ng-container>
